import { Component, OnDestroy } from '@angular/core';
//import { NgbModule } from '@ng-bootstrap/ng2-bootstrap';
import { navmenuservices } from './nav-menu.services';
import { Router } from '@angular/router';
import { navmenu } from './nav-menu';
import { ToastrService } from 'ngx-toastr';
import { UseraddService } from '../Master/useradd/useradd.service';
import { DomSanitizer } from '@angular/platform-browser';
import { User } from '../Master/user/user';
import { AdminAccessrightService } from '../accessrightsadmin/accessrightsadmin.service';
import { Observable, timer } from 'rxjs';
import $ from 'jquery';
import { LocalService } from '../local.service';

@Component({
  selector: 'app-nav-menu',
  templateUrl: './nav-menu.component.html',
  styleUrls: ['./nav-menu.component.css'],
  providers: [AdminAccessrightService, navmenuservices]
})
export class NavMenuComponent {
  //public list: any[];
  //timervalue: Observable<Number> = timer(0, 3000);
  timervalue: Observable<Number> = timer(0, 120000);
  subscription: any;

  public list;
  public list1;
  //public userid = localStorage.getItem('userid');
  public userid = this.localService.getJsonValue('userid');
  //public username = localStorage.getItem('username');
  public username = this.localService.getJsonValue('username');
  //userrole = localStorage.getItem('userrole');
  userrole = this.localService.getJsonValue('userrole');
  imagepath: any;
  user: User;

  accesscount: number;
  constructor(private _router: Router, private navmenuservice: navmenuservices, private toastr: ToastrService,
    private UseraddService: UseraddService, private _sanitizer: DomSanitizer,
    private adminaccessrightService: AdminAccessrightService, private localService: LocalService) { }
  ngOnInit() {
    this.accesscount = 0;
    this.LoadAccessCount();
    this.navmenuservice.postdata(this.userid).subscribe((res) => {
      
      if (res != undefined) {
        this.list = res;
      }
    }, error => { this.toastr.error(error.error) });

    if (this.userrole == 'Admin') {
      this.subscription = this.timervalue.subscribe(() => {
        this.LoadAccessCount();
      });
    }

    this.navmenuservice.getmenulist(this.userid).subscribe((res) => {
      
      if (res != undefined) {
        this.localService.setJsonValue('menulist', res);
        this.list1 = res;
      }
    }, error => { this.toastr.error(error.error) });

    this.UseraddService.GetById(+this.userid).subscribe(res => {
      if (res != undefined) {
        this.user = res.find(u => u.userid == +this.userid);
        //this.user = res;
        if (this.user.profileimagepath != null) {
          this.UseraddService.GetImage(this.user.profileimagepath).subscribe(res => {
            if (res.type != 'text/plain') {
              let objectURL = 'data:image/jpeg;base64,' + res.image;
              this.imagepath = this._sanitizer.bypassSecurityTrustUrl(objectURL);
            }
          }, error => { });
        }
        else {
          this.imagepath = "../../assets/images/img.jpg";
        }
      }
    }, error => { });
  }

  LoadAccessCount() {
    this.adminaccessrightService.Get().subscribe(res => {

      this.accesscount = res.length;
      if (this.accesscount > 0) {
        $("#accesscount").css("display", "block");
        if ($('#accesscount')[0] != undefined) {
          $('#accesscount')[0].innerText = this.accesscount;
        }
      }
      else {
        $("#accesscount").css("display", "none");
      }
      //console.log('latest ' + this.accesscount);
    }, error => { });
  }
  ngOnDestroy() {
    //console.log('timer destroyd');
    if (this.subscription != null && this.subscription != undefined) {
      this.subscription.unsubscribe();
    }
  }

}
